import NullOrUndefinedHelper from "@/utilities/system/helpers/NullOrUndefinedHelper";
import {useSystemStore} from "@/stores/system/SystemStore";

export default function changeTitle ({next}:any){
    const systemStore = useSystemStore();
    const defaultSystemCompanyName = systemStore.settings.systemCompanySettings?.companyName;

    if (!NullOrUndefinedHelper(defaultSystemCompanyName)){
        document.title = `1ANV Web | ${defaultSystemCompanyName}`;
    }

    return next();
}